import { useContext, useEffect } from 'react';
import { useLoaderData, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import RecruiterDirectoryService from './RecruiterDirectoryService';
import RecruiterSearchControl from './RecruiterSearchControl';
import RecruiterCardGridControl from './RecruiterCardGridControl';
import RecruiterSummaryCardControl from './RecruiterSummaryCardControl';
import SmartContextPage from '../../../library/Core/SmartContextPage';

const RecruiterDirectory = () => {
    const { pageName } = useParams();
    const { globalState } = useContext(GlobalContext);

    const [searchParams] = useSearchParams();
    const universityId = searchParams.get('universityId');

    const navigate = useNavigate();

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        data: { filters: {} },
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { ROUTER_NAVIGATE: navigate },
    } as any);

    const { formConfig, data, internal } = useLoaderData() as State;

    useEffect(() => {
        const domain = globalState.domain;
        const searchFilterDomains = RecruiterDirectoryService.getSearchFilterDomains(domain, internal.searchFilterDomains);
        const filters = {
            ...RecruiterDirectoryService.getDefaultSearchCriteria(data.searchBy),
            universityId: universityId ? [universityId] : [],
        };
        const timer = setTimeout(() => {
            dispatch({
                type: 'DATA_INIT',
                payload: {
                    formConfig,
                    data: { ...data, searchDomain: searchFilterDomains, filters },
                    internal: { ...internal, searchFilterDomains },
                    domain,
                    routeInfo: { pageName },
                },
            });
        }, 0);
        return () => clearTimeout(timer);
    }, []);

 
    return (
        <SmartContextPage state={state} dispatch={dispatch} showDebug={false} message="Loading recruiter directory...">
            <>
                <RecruiterSummaryCardControl />
                <RecruiterSearchControl />
                <RecruiterCardGridControl />
            </>
        </SmartContextPage>
    );
};

export default RecruiterDirectory;
